<div class="dropdown d-flex w-full">
  <app-button styleType="clear-secondary" type="button" id="cityDropdown" data-bs-toggle="dropdown"
    aria-expanded="false" icon="pi pi-map-marker" style="font-size: small;">
    {{ selectedCity() ?? "Selecionar Cidade" }}
  </app-button>
  <ul class="dropdown-menu city-dropdown__menu" aria-labelledby="cityDropdown">
    <li class="city-dropdown__search" (click)="$event.stopPropagation()">
      <span class="city-dropdown__search-icon"><i class="pi pi-search"></i></span>
      <input type="search" class="form-control city-dropdown__search-input" placeholder="Buscar cidade"
        [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)" />
    </li>
    @if (filteredCities().length === 0) {
    <li><span class="dropdown-item disabled">Nenhuma cidade encontrada</span></li>
    } @else {
    <li>
      <a class="dropdown-item" href="javascript:void(0)" (click)="selectCity(null)"> Todas as cidades </a>
    </li>
    @for (city of filteredCities(); track city) {
    <li>
      <a class="dropdown-item" href="javascript:void(0)" (click)="selectCity(city)">{{ city }}</a>
    </li>
    }
    }
  </ul>
</div>